import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export default async function fetchBySchool (model, url, primaryKey = 'id') {
  const { data, network, headers } = await GlobalPrototypes.cacheHttp(url)

  model.insertOrUpdate({ data })

  const res = await network()

  if (!res || !res.data || (res.headers.etag && res.headers.etag === headers.etag)) return

  const newIds = res.data.map(el => el[primaryKey])

  // remove old ids - since not every model has "id" as primaryKey it can be set via param
  const oldIds = data.filter((el) => !newIds.includes(el[primaryKey])).map(el => el[primaryKey])

  await model.delete(record => oldIds.includes(record[primaryKey]))

  model.insertOrUpdate({ data: res.data })

  return res
}
